// extracted by mini-css-extract-plugin
export default {"headMasterData":"HeadOfMasterData_headMasterData__JY-5s","row":"HeadOfMasterData_row__dHt9q","redText":"HeadOfMasterData_redText__M2hVV"};